import React, { useEffect, useState, useRef } from "react";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import { InviteViaMail, SentMailList } from "./../device-selection/actions";
import SimpleReactValidator from "simple-react-validator";
import { meetingURL } from "../../common";

function InviteViaEmailPopup({ handleClose, uniquekey }) {
    const [, forceUpdate] = useState();
    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate: forceUpdate },
        })
    );
    const emailvalidator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate: forceUpdate },
        })
    );
    const [email_list, setEmailList] = useState([]);
    const [member_list, setMemberList] = useState([]);
    const [members, setMembers] = useState([]);
    const [email, setEmail] = useState("");
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
        $(".email-invitee").draggable({
            handle: ".email-key",
            containment: "#InviteViaEmail",
        });
        GetMailList();
    }, []);

    const GetMailList = async () => {
        let response = await APP.store.dispatch(
            SentMailList({ meeting_code: uniquekey })
        );
        console.log("GetMailList1", response);
        if (response.code === 1) {
            setEmailList(response.response);
        }
    };

    const SendEmail = async () => {
        if (!validator.current.allValid()) {
            validator.current.showMessages();
            forceUpdate(1);
            return;
        }
        setClicked(true);
        let response = await APP.store.dispatch(
            InviteViaMail({
                email: members.map((val) => val.label),
                meeting_code: uniquekey,
                link: meetingURL(),
            })
        );
        if (response === 1) {
            GetMailList();
            setMembers([]);
        }
        setClicked(false);
    };

    const RemindEmail = async () => {
        setClicked(true);
        let response = await APP.store.dispatch(
            InviteViaMail({
                email: member_list,
                meeting_code: uniquekey,
                link: meetingURL(),
            })
        );
        if (response === 1) {
            GetMailList();
            setMemberList([]);
        }
        setClicked(false);
    };

    const handleDelete = (emailToDelete) => () => {
        setMembers(
            members.filter((response) => response.key !== emailToDelete.key)
        );
    };

    const handleKeyDown = (evt) => {
        if (evt.key === "Backspace" && evt.target.value === "") {
            setEmail(
                () => {
                    members?.[members.length - 1]?.label ?? "";
                },
                () => {
                    members.pop();
                    setMembers(members);
                }
            );
        }
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            if (!emailvalidator.current.allValid()) {
                emailvalidator.current.showMessages();
                forceUpdate(1);
                return false;
            }
            var value = email.trim();
            if (value && !isInList(value)) {
                setMembers([...members, { key: members.length, label: value }]);
            }
            setEmail("");
        }
    };

    const handleChange = (evt) => {
        setEmail(evt.target.value);
    };

    const isInList = (email) => {
        return members.filter((list) => list.label === email).length;
    };

    return (
        <div className="invite-popup">
            <div className="invite-remind">
                <h3>
                    Invite and Remind
                    <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                    >
                        <span aria-hidden="true">
                            <img
                                src="public/assets/images/invite-cross.svg"
                                alt="1"
                            />
                        </span>
                    </button>
                </h3>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <a
                            className="nav-link active show"
                            id="email-meet-tab"
                            data-toggle="tab"
                            href="#eamil-meet"
                            role="tab"
                            aria-controls="eamil-meet"
                            aria-selected="false"
                        >
                            {/* <span className="bg-pos-ico invite-email"></span> */}
                            <img
                                src="public/assets/images/msg--black.png"
                                className="icon-black"
                            />
                            <img
                                src="public/assets/images/msg--blue.png"
                                className="icon-blue"
                            />
                            <span className="d-block">Email</span>
                        </a>
                    </li>
                    <li className="nav-item" role="presentation">
                        <a
                            className="nav-link"
                            id="remind-meet-tab"
                            data-toggle="tab"
                            href="#remind-meet"
                            role="tab"
                            aria-controls="remind-meet"
                            aria-selected="false"
                        >
                            {/* <span className="bg-pos-ico"></span> */}
                            <img
                                src="public/assets/images/clock--black.png"
                                className="icon-black"
                            />
                            <img
                                src="public/assets/images/clock--blue.png"
                                className="icon-blue"
                            />
                            <span className="d-block">Remind</span>
                        </a>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div
                        className="tab-pane eamil-meet fade active show"
                        id="eamil-meet"
                        role="tabpanel"
                        aria-labelledby="email-meet-tab"
                    >
                        <div className="invite-eamil-textarea">
                            <label for="exampleFormControlTextarea1">
                                Invites:
                            </label>
                            <Paper component="ul" className="email-input-ul">
                                {members.map((data) => {
                                    let icon;
                                    return (
                                        <li key={data.key}>
                                            <Chip
                                                icon={icon}
                                                label={data.label}
                                                onDelete={handleDelete(data)}
                                                className={"chip-org"}
                                            />
                                        </li>
                                    );
                                })}
                                <input
                                    className="form-control w-100"
                                    name="email"
                                    value={email}
                                    placeholder="Type email"
                                    onKeyDown={handleKeyDown}
                                    onChange={handleChange}
                                    onBlur={() =>
                                        handleKeyDown({
                                            key: "Enter",
                                            preventDefault: () => {
                                                return null;
                                            },
                                        })
                                    }
                                />
                            </Paper>
                            {emailvalidator.current.message(
                                "Email",
                                email,
                                "email"
                            )}
                            {validator.current.message(
                                "Members",
                                members,
                                "required"
                            )}
                            <p>Seperate addresses with commas or semicolons.</p>
                        </div>
                        <div className="invite-team-member-div">
                            <h6>Invite by using your email application</h6>
                            <a
                                className="invite-team-member-link"
                                onClick={SendEmail}
                            >
                                {clicked ? "Please Wait..." : "Send Message"}
                            </a>
                        </div>
                    </div>
                    <div
                        className="tab-pane remind-meet fade"
                        id="remind-meet"
                        role="tabpanel"
                        aria-labelledby="remind-meet-tab"
                    >
                        <p>
                            The following guests have not joined your meeting.
                            Select the guests you wish to remind
                        </p>
                        <div className="search-team-check-list">
                            {email_list && email_list?.length > 0 ? (
                                email_list.map((values, keys) => {
                                    return (
                                        <div
                                            className="form-check"
                                            key={`data${keys}`}
                                        >
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(e) =>
                                                    setMemberList(
                                                        e.target.checked
                                                            ? [
                                                                  ...member_list,
                                                                  values.email,
                                                              ]
                                                            : member_list.filter(
                                                                  (val) =>
                                                                      val !==
                                                                      values.email
                                                              )
                                                    )
                                                }
                                                id={`defaultCheck${keys}`}
                                                checked={member_list.includes(
                                                    values.email
                                                )}
                                            />
                                            <label
                                                className="form-check-label"
                                                for={`defaultCheck${keys}`}
                                            >
                                                {values.email}
                                            </label>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="form-check">
                                    <label className="form-check-label">
                                        No participant for remind <br />
                                        please send mail to it for reminding
                                    </label>
                                </div>
                            )}
                        </div>
                        <h4>Send reminders with your local email</h4>
                        <div className="invite-team-member-div">
                            <a
                                className="invite-team-member-link"
                                onClick={RemindEmail}
                            >
                                {clicked ? "Please Wait..." : "Send Reminder"}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InviteViaEmailPopup;
